module.exports = __webpack_public_path__ + "img/pro_dcsj.fdd4cb70.svg";